import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Batch id',
    value: 'productionId',
  },
  {
    label: 'Date',
    value: 'actualProcessDatelb',
  },
  {
    label: 'Process',
    value: 'processName',
  },
  {
    label: 'Facility Name',
    value: 'pickupPointName',
  },
  // {
  //   label: 'Category',
  //   value: 'name',
  // },
  {
    label: 'Item',
    value: 'lbitem',
  },
  {
    label: 'Qty',
    value: 'lbQty',
  },
  // {
  //   label: 'Test Result',
  //   value: 'name',
  // },

  {
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
